export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7042.da607c46.jpg";